module.exports = __webpack_public_path__ + "static/img/loading.f78f635.gif";


//////////////////
// WEBPACK FOOTER
// ./static/img/loading.gif
// module id = B3Bl
// module chunks = 1